import { Component, Input, Output, OnInit, EventEmitter } from "@angular/core";
import { ProductModel } from "src/app/models/product.model";
import { DataService } from "src/app/services/data/data.service";



@Component({
  selector: "reorderer",
  templateUrl: "./reorderer.component.html",
  styleUrls: ["./reorderer.component.scss"]
})
export class ReordererComponent implements OnInit {
  
  loading = false;
  
  @Input()
  title: string;

  @Input()
  items: ProductModel[];

  @Input()
  public onReOrder = () => {};

  @Input()
  public onCancel = () => {};

  @Output() reOrdered = new EventEmitter<ProductModel[]>();

  constructor(private dataService:DataService) {}

  ngOnInit(): void {}

  doReorder(event){
    console.log(event);
    this.items.splice(event.detail.to,0,this.items.splice(event.detail.from,1)[0]);
    event.detail.complete();
  }

  cancel(){
    this.onCancel();
  }

  async submit(){
    this.loading = true;
    await this.items.forEach(async (product, i) => {
      product.details.rank = i;
      await this.dataService.updateProductRank(product);
    }); 
    this.loading = false;
    this.onReOrder();
  }
}
